import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "convertMonth",
})
export class ConvertMonthPipe implements PipeTransform {
  transform(field: number): string {
    if (!field) return "";
    const months = [
      "",
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return months[field] || "";
  }
}
